// extracted by mini-css-extract-plugin
export default {"topic":"create-event_topic__dRWx+","keyWords":"create-event_keyWords__KEKrZ"};